import React, { useState, useEffect } from 'react';
import { Button, Card, CardText, CardTitle, Col, Input, Label, ListGroup, ListGroupItem, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import LoaderButton from '../../loader-button/LoaderButton';
// import BZAPIService from '../../../services/BZAPIService';
import { includes } from 'lodash';
import PropTypes from 'prop-types';

export default function CategoryFilter({
  vendorId,
  vendorLabel,
  loader,
  setLoader,
  // Fortinet
  vendorBugServiceOptions,
  setVendorBugServices,
  vendorBugServices,
  // F5
  vendorProductBugCategories,
  setVendorProductBugCategories,
  vendorProductBugCategoryOptions
}) {
  const [activeItems, setActiveItems] = useState([]);
  const [search, setSearch] = useState('');
  const [availableComponents, setAvailableComponents] = useState();
  const [excludedComponents, setExcludedComponents] = useState([]);
  const [filtered, setFiltered] = useState([]);

  useEffect(() => {
    setLoader(true);
    setActiveItems([]);
    if (vendorProductBugCategoryOptions?.length) {
      let excluded = vendorProductBugCategories.map(item => item.value);
      setExcludedComponents(
        vendorProductBugCategories.length
          ? vendorProductBugCategoryOptions.filter(item => !excluded.includes(item.value))
          : []
      );
      if (vendorProductBugCategories?.length) {
        setAvailableComponents(vendorProductBugCategories);
        setFiltered(vendorProductBugCategories);
      } else {
        setAvailableComponents(vendorProductBugCategoryOptions);
        setVendorProductBugCategories(vendorProductBugCategoryOptions);
        setFiltered(vendorProductBugCategoryOptions);
      }
    }
    if (vendorBugServiceOptions?.length) {
      let excluded = vendorBugServices.map(item => item.value);
      setExcludedComponents(
        vendorBugServices.length ? vendorBugServiceOptions.filter(item => !excluded.includes(item.value)) : []
      );
      // console.log();
      if (vendorBugServices?.length) {
        setAvailableComponents(vendorBugServices);
        setFiltered(vendorBugServices);
      } else {
        setAvailableComponents(vendorBugServiceOptions);
        setVendorBugServices(vendorBugServiceOptions);
        setFiltered(vendorBugServiceOptions);
      }
    }

    setLoader(false);

    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function excludeComponent(e) {
    const availableCopy = availableComponents;
    setExcludedComponents(excludedComponents.concat(activeItems));
    setAvailableComponents(availableCopy.filter(item => !includes(activeItems, item)));

    if (vendorId === 'f5' || vendorId === 'ctrxns') {
      setVendorProductBugCategories(availableCopy.filter(item => !includes(activeItems, item)));
      setFiltered(availableCopy.filter(item => !includes(activeItems, item)));
    }
    if (vendorId === 'fortinet') {
      setVendorBugServices(availableCopy.filter(item => !includes(activeItems, item)));
      setFiltered(availableCopy.filter(item => !includes(activeItems, item)));
    }
    setActiveItems([]);
    setSearch('');
    setLoader(false);
  }
  async function includeComponent() {
    setLoader(true);
    const excludedCopy = excludedComponents;

    setExcludedComponents(excludedCopy.filter(item => !includes(activeItems, item)));
    setAvailableComponents(availableComponents.concat(activeItems));
    if (vendorId === 'f5') {
      setVendorProductBugCategories(availableComponents.concat(activeItems));
      setFiltered(availableComponents.concat(activeItems));
    }
    if (vendorId === 'fortinet') {
      setVendorBugServices(availableComponents.concat(activeItems));
      setFiltered(availableComponents.concat(activeItems));
    }
    setActiveItems([]);
    setSearch('');
    setLoader(false);
  }
  const selectComponent = (e, which) => {
    const item = e.currentTarget.id;
    const itemObject =
      which === 'available' ? filtered.filter(i => i.value === item) : excludedComponents.filter(i => i.value === item);
    console.log('item: ', item);
    const included = activeItems.filter(i => i.value === item).length ? true : false;
    console.log('includes? ', included);
    if (!included) {
      setActiveItems(activeItems.concat(itemObject));
    } else {
      setActiveItems(activeItems.filter(i => i.value !== item));
    }
    // console.log('active items: ', activeItems);
  };

  const handleSearchChange = async e => {
    const k = e.target.value;
    setSearch(k);
    setFiltered(availableComponents.filter(item => item.value.toLowerCase().includes(k)));
  };

  return (
    <>
      <div className="mb-4">
        <CardTitle data-testid={'modules-filter-label'}>Filter {vendorLabel} Modules</CardTitle>
        <CardText>Select multiple entries if necessary</CardText>
        <Row>
          <Col sm={5} className="mb-2">
            <Input
              type="text"
              name="search"
              id="search"
              placeholder="Search..."
              value={search}
              onChange={e => handleSearchChange(e)}
              onKeyDown={e =>
                e.target.value.length === 0 && e.key === 'Enter' && setAvailableComponents(...availableComponents)
              }
              data-testid={'modules-filter-search'}
            />
          </Col>
        </Row>
        <Row>
          <Col md="5">
            <Row className="mt-2">
              <Col>
                <Label>Available Modules</Label>
              </Col>
              <Col className="text-right mb-2">
                <Button
                  size="sm"
                  className="btn btn-link text-muted p-0"
                  onClick={e => setActiveItems(!activeItems.length ? filtered : [])}
                  data-testid={'availableComponents-select-all-btn'}
                  disabled={!availableComponents?.length}
                >
                  {activeItems?.length && includes(availableComponents, activeItems[0]) ? 'Deselect all' : 'Select all'}
                </Button>
              </Col>
            </Row>

            <Card className="bg-white">
              {/* <p className="text-danger">{componentError}</p> */}
              <ListGroup
                style={{ maxHeight: '400px', minHeight: '400px', overflowY: 'scroll' }}
                data-testid={'available-modules-list'}
              >
                {filtered?.length ? (
                  filtered.map(item => (
                    <ListGroupItem
                      key={item.value + '-available'}
                      id={item.value}
                      role="button"
                      style={{ border: '0px' }}
                      onClick={e => selectComponent(e, 'available')}
                      active={includes(activeItems, item)}
                    >
                      {item.label}
                    </ListGroupItem>
                  ))
                ) : (
                  <ListGroupItem style={{ border: '0px' }}>No results found</ListGroupItem>
                )}
              </ListGroup>
            </Card>
          </Col>
          <Col md={2} className="align-middle text-center my-auto">
            <Row>
              <Col className="align-middle text-center my-auto">
                <LoaderButton
                  onClick={e => excludeComponent(e)}
                  isLoading={loader}
                  color="falcon-default"
                  size="sm"
                  className="mt-2"
                  data-testid={'exclude-btn'}
                  disabled={!availableComponents?.length}
                >
                  <FontAwesomeIcon icon={faArrowRight} />
                </LoaderButton>
              </Col>
            </Row>
            <Row>
              <Col className="align-middle text-center my-auto">
                <LoaderButton
                  onClick={e => includeComponent(e)}
                  isLoading={loader}
                  color="falcon-default"
                  size="sm"
                  className="mt-2"
                  data-testid={'include-btn'}
                  disabled={!excludedComponents?.length}
                >
                  <FontAwesomeIcon icon={faArrowLeft} />
                </LoaderButton>
              </Col>
            </Row>
          </Col>
          <Col md="5">
            <Row className="mt-2">
              <Col>
                <Label>{vendorLabel} Modules to Exclude</Label>
              </Col>
              <Col className="text-right mb-2">
                <Button
                  size="sm"
                  className="btn btn-link text-muted p-0"
                  onClick={e => setActiveItems(!activeItems.length ? excludedComponents : [])}
                  data-testid={'availableComponents-select-all-btn'}
                  disabled={!excludedComponents?.length}
                >
                  {activeItems?.length && includes(excludedComponents, activeItems[0]) ? 'Deselect all' : 'Select all'}
                </Button>
              </Col>
            </Row>

            <Card className="bg-white">
              <ListGroup
                style={{ maxHeight: '400px', minHeight: '400px', overflowY: 'scroll' }}
                data-testid={'excluded-modules-list'}
              >
                {excludedComponents.map(item => (
                  <ListGroupItem
                    key={item.value + '-excluded'}
                    role="button"
                    style={{ border: '0px' }}
                    id={item.value}
                    onClick={e => selectComponent(e, 'excluded')}
                    active={includes(activeItems, item)}
                  >
                    {item.label}
                  </ListGroupItem>
                ))}
              </ListGroup>
            </Card>
          </Col>
        </Row>
        <br />
      </div>
    </>
  );
}

CategoryFilter.propTypes = {
  vendorId: PropTypes.string,
  vendorLabel: PropTypes.string,
  includedComponents: PropTypes.array,
  setIncludedComponents: PropTypes.func,
  excludedComponents: PropTypes.array,
  setExcludedComponents: PropTypes.func,
  loader: PropTypes.bool,
  setLoader: PropTypes.func,
  vendorBugServiceOptions: PropTypes.array,
  setVendorBugServices: PropTypes.func,
  vendorBugServices: PropTypes.array,
  vendorProductBugCategories: PropTypes.array,
  setVendorProductBugCategories: PropTypes.func,
  vendorProductBugCategoryOptions: PropTypes.array
};
